import { render, staticRenderFns } from "./DeleteCategoryModal.vue?vue&type=template&id=eaaae510&"
import script from "./DeleteCategoryModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DeleteCategoryModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports